import Component from "@glimmer/component";
import { service } from "@ember/service";
import DButton from "discourse/ui-kit/d-button";

export default class CommunityNavigationHeaderMenu extends Component {
  @service communityNavigation;

  <template>
    {{#if this.communityNavigation.active}}
      <li
        class="header-dropdown-toggle community-navigation-header-menu"
      >
        <DButton
          id="toggle-community-navigation"
          @action={{this.communityNavigation.openMobile}}
          @ariaLabel="hamburger_menu"
          @icon="bars"
          @title="hamburger_menu"
          aria-expanded={{if this.communityNavigation.mobileOpen "true" "false"}}
          aria-controls="community-navigation-drawer"
          aria-haspopup="dialog"
          class="btn-flat icon community-navigation-header-menu__button"
        />
      </li>
    {{/if}}
  </template>
}
